/**
 * A picked file as the `data:<type>;name=<name>;base64,` URL a `file` task input is started with (os#679). The
 * start body is JSON, so the file travels the way an avatar already does; the name rides as a data URL parameter
 * so the run lists the file under the name the person picked rather than the input's key.
 */
export function fileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(withName(typeof reader.result === 'string' ? reader.result : '', file.name))
        reader.onerror = () => reject(reader.error ?? new Error('file_unreadable'))
        reader.readAsDataURL(file)
    })
}

/** `data:<type>;base64,…` with `;name=<encoded name>` put before `;base64`, or the URL as it was without a name. */
export function withName(dataUrl: string, name: string): string {
    const marker = dataUrl.indexOf(';base64,')
    if (marker < 0 || name === '') {
        return dataUrl
    }
    return `${dataUrl.slice(0, marker)};name=${encodeURIComponent(name)}${dataUrl.slice(marker)}`
}
